import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Header, TituloCentrado, ContenedorHeader } from '../elementos/Header';
import { Formulario, Input, ContenedorBoton } from '../elementos/ElementosDeFormulario';
import Boton from '../elementos/Boton';
// import { ReactComponent as SvgLogin } from './../imagenes/login.svg';
import PasswordImg from './../imagenes/password.png';
import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
import { auth } from './../firebase/firebaseConfig';
import { sendPasswordResetEmail } from "firebase/auth";
import Alerta from './../elementos/Alerta';
import BtnRegresar from '../elementos/BtnRegresar';

const ImgStyles = styled.img`
    width: 150px !important;
    height: auto;
    margin: 0 auto;
    margin-bottom: 1rem;
`;

const InicioSesion = () => {
    // Creamos 3 estados para cada input
    const [correo, establecerCorreo ] = useState('');

    // Creamos un nuevo estado para las alertas
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);

    // Creamos otro estado para el mensaje de alerta
    const [alerta, cambiarAlerta] = useState({});

    const handleChange = (e) => {
        if(e.target.name === 'email') {
            establecerCorreo(e.target.value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        // Comprobamos del lado del cliente que el correo sea válido
        const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
        
        // Comprobamos que el campo correo sea un correo
        if( !expresionRegular.test(correo) ) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'Por favor ingresa un correo válido'
            });
            return;
        }

        // Crear nueva cuenta usando Firebase y atrapar errores
        try {
            await sendPasswordResetEmail(auth, correo);
            
            setTimeout(() => {
                cambiarEstadoAlerta(true);
                let mensaje = 'Se ha enviado un mensaje de recuperación de contraseña a tu correo';
                cambiarAlerta({tipo: 'exito', mensaje: mensaje});
                establecerCorreo('');
            }, 2000);
        } catch(error) {
            cambiarEstadoAlerta(true);
            let mensaje;
            switch(error.code){
                case 'auth/user-not-found':
                    mensaje = 'No se encontró ninguna cuenta con este correo electrónico'
                    break;
                default:
                    mensaje = 'Hubo un error al intentar iniciar sesión'
                break;

            }
            cambiarAlerta({ tipo: 'error', mensaje: mensaje })
        }
    };

    return (  
        <>
            <Helmet>
                <title>Recuperar contraseña</title>
            </Helmet>

            <Header>
                <ContenedorHeader>
                    <BtnRegresar/>
                    <TituloCentrado>Recuperar contraseña</TituloCentrado>
                </ContenedorHeader>
            </Header>

            <Formulario onSubmit={handleSubmit}>
                <ImgStyles src={PasswordImg} alt='Password'/>
                <Input 
                    type='email'
                    name='email'
                    placeholder='Correo electrónico'
                    value={ correo }    
                    onChange = { handleChange }
                />
                <ContenedorBoton>
                    <Boton as="button" primario type='submit'>Restablecer contraseña</Boton>
                </ContenedorBoton>
            </Formulario>

            <Alerta 
                tipo = { alerta.tipo }
                mensaje = { alerta.mensaje }
                estadoAlerta = { estadoAlerta }
                cambiarEstadoAlerta = { cambiarEstadoAlerta }
            />
        </>
    );
}
 
export default InicioSesion;